import React from 'react'
import { Content } from './styles'

type RenderSVGType = {
  children: React.ReactNode
}

function RenderSVG(props: RenderSVGType) {
  return <Content>{props.children}</Content>
}

export default RenderSVG
